export const capitalize: (string: string | null) => string = (
  string,
) => {
  if (string === '' || string === null) {
    return '';
  }

  const [first, ...rest] = string.split('');
  return first.toUpperCase() + rest.join('').toLowerCase();
};

export const titelize: (string: string | null) => string = (string) => {
  if (!string || string === '' || string === null) {
    return '';
  }

  return string
    .split(' ')
    .map((word: string) => capitalize(word))
    .join(' ');
};

export const formatNumberToIntegerTruncatedString = (value?: number): string => (value ? Math.trunc(value).toString() : '0');

export const formatValue: (value: number | string | null | undefined) => string = (value) => (value && value !== '' && value !== 'null' ? value.toString() : '-');

export const stringToNumber = (value: string, defaultResult = 0): number => {
  const parsedValue = parseInt(value ?? '0', 10);
  return Number.isNaN(parsedValue) ? defaultResult : parsedValue;
};
